<template>
    <div>
      <v-card>
        <v-card-text>
          
        <h3>Finished Date</h3>
          <v-row>
            <v-col lg="3">
              <label>From Date</label>
              <v-menu
                ref="finished_menu"
                v-model="finished_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="finished_from_date"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="finished_from_date"
                  no-title
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col lg="3">
              <label>To Date</label>
              <v-menu
                ref="finished_menu_end"
                v-model="finished_menu_end"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="finished_to_date"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="finished_to_date"
                  no-title
                  @input="menu_end = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div>
            <h3>Issue Date</h3>
            <v-row>
              <v-col lg="3">
                <label>From Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="issue_from_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="issue_from_date"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col lg="3">
                <label>To Date</label>
                <v-menu
                  ref="menu_end"
                  v-model="menu_end"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="issue_to_date"
                      outlined
                      dense
                      readonly
                      persistent-hint
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="issue_to_date"
                    no-title
                    @input="menu_end = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- <v-col lg="3">
                <br>
                <v-btn class="form-btn" @click="exportIssue">
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
              </v-btn>
              </v-col> -->
            </v-row>
          <v-row>
            <v-col lg="3">
              <v-btn class="form-btn" @click="exportOutcome">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
            </v-btn>
            </v-col>
          </v-row>
          </div>

        </v-card-text>
        <v-card-actions>
         
          
        </v-card-actions>
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import moment from "moment";
  
  export default {
    components: {},
    data: () => ({
      township_group:  null,
      finished_township_group_id: null,

      issue_from_date: null,
      issue_to_date:null,

      finished_from_date: null,
      finished_to_date: null,

      menu: false,
      menu_end: false,

      finished_menu: false,
      finished_menu_end: false,
    }),
    computed: {
      ...mapState("Admin", ["admin"]),
    },
    methods: {

      exportOutcome() {
        let data = {
          township_group_id: this.admin.township_group_id,
        };
        
        // Check if Issue Date is partially filled
        const hasIssueFrom = this.issue_from_date;
        const hasIssueTo = this.issue_to_date;
        const hasFinishedFrom = this.finished_from_date;
        const hasFinishedTo = this.finished_to_date;
        
        // Validate Issue Date - if one is filled, both must be filled
        if (hasIssueFrom && !hasIssueTo) {
          alert('Please fill both Issue Date from and to dates');
          return false;
        }
        if (!hasIssueFrom && hasIssueTo) {
          alert('Please fill both Issue Date from and to dates');
          return false;
        }
        
        // Validate Finished Date - if one is filled, both must be filled
        if (hasFinishedFrom && !hasFinishedTo) {
          alert('Please fill both Finished Date from and to dates');
          return false;
        }
        if (!hasFinishedFrom && hasFinishedTo) {
          alert('Please fill both Finished Date from and to dates');
          return false;
        }
        
        // Check if at least one complete date range is filled
        const hasIssueRange = hasIssueFrom && hasIssueTo;
        const hasFinishedRange = hasFinishedFrom && hasFinishedTo;
        
        if (!hasIssueRange && !hasFinishedRange) {
          alert('Please fill at least one complete date range');
          return false;
        }
        
        // Add Issue Date to data if both dates are filled
        if (hasIssueRange) {
          data.issue_from_date = moment(this.issue_from_date).format("YYYY-MM-DD");
          data.issue_to_date = moment(this.issue_to_date).format("YYYY-MM-DD");
          
          if (data.issue_from_date > data.issue_to_date) {
            alert('Issue Date: From date cannot be greater than to date!');
            return false;
          }
        }
        
        // Add Finished Date to data if both dates are filled
        if (hasFinishedRange) {
          data.finished_from_date = moment(this.finished_from_date).format("YYYY-MM-DD");
          data.finished_to_date = moment(this.finished_to_date).format("YYYY-MM-DD");
          
          if (data.finished_from_date > data.finished_to_date) {
            alert('Finished Date: From date cannot be greater than to date!');
            return false;
          }
        }
        
        this.$store.dispatch("Presumptive/finishedExport", data);
      },
    },
  };
  </script>